import styled, { css } from 'styled-components';

export const Container = styled.div`
  grid-area: details;
  background-color: #eee;
  border: 1px solid gray;
  border-radius: 3px;
  padding: 10px 5px;
`;

export const Label = styled.label``;

export const TrackWrapper = styled.div`
  grid-row: 1;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const CenteredTrack = styled.div`
  text-align: center;
  margin: 3px 0px;
  ${(props) => props.disabled && '* {color: #aaa}'}
  && label {
    font-weight: bold;
  }
`;

export const Track = styled.div`
  display: flex;
  width: 100%;
  ${(props) => props.disabled && '* {color: #aaa}'}
  &:last-child {
    align-items: center;
    box-sizing: border-box;
    padding: 10px;
  }
  && img:hover {
    box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.5);
  }
`;

export const TrackKey = styled.div`
  width: 35%;
  padding: 5px;
  margin: 5px 0px;
  text-align: left;
  font-weight: bold;
`;

export const TrackValue = styled.div`
  text-align: right;
  padding: 5px;
  margin: 5px 0px;
  width: 65%;
`;

export const ProxyBid = styled.div`
  ${({ inPlay }) => css`
    line-height: 2em;
    border-radius: 3px;
    margin-bottom: 1px;
    background-color: ${inPlay ? '#21BA45' : '#FBCC08'};
    color: ${inPlay ? '#FFFFFF' : '#000000'};
  `};
`;

export const PrivateCommentsContainer = styled(CenteredTrack)`
  background-color: #DFEBE2;
  color: #000; 
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
  }
  & > div:last-child {
    height: 85px;
    overflow-y: auto;
  }
  & i:hover {
    cursor: pointer;
  }
`;

export const PublicCommentsContainer = styled(CenteredTrack)`
  background-color: #A6B9AA;
  color: #000;
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
  }
  & > div:last-child {
    height: 85px;
    overflow-y: auto;
  }
  & i:hover {
    cursor: pointer;
  }
`;
